module.exports = __webpack_public_path__ + "assets/img/Asset4.c33ee314.png";